import { KeyValue } from '@angular/common';
import { Sex } from '../enums';

export const SEX_VALUES: KeyValue<Sex, string>[] = [
  {
    key: Sex.Unknow,
    value: 'Desconocido'
  },
  {
    key: Sex.Man,
    value: 'Hombre'
  },
  {
    key: Sex.Woman,
    value: 'Mujer'
  }
] as KeyValue<Sex, string>[];
